import moment from 'moment/moment'

export function priceToFormat (price) {
  return new Intl.NumberFormat("ru-ru", { style: "currency", currency: "RUB", maximumSignificantDigits: 10 }).format(price)
}

export function getApiUrl () {
  return process.env.VUE_APP_API_URL_1
}

export function formatDate (date, type) {
  if (type === 'onlyDate') {
    return moment(date).format('DD.MM.YYYY')

  }

  return moment(date).format('dd - DD.MM.YYYY HH:mm')
}

export function parseCookies () {
  return document.cookie
    .split('; ')
    .reduce((acc, cookie) => {
      const [key, value] = cookie.split('=')

      acc[key] = decodeURIComponent(value)

      return acc
    }, {})
}

export function checkTtlDate ({ timeUpdate, ttlTime }) {
  const passedTime = Date.now() - timeUpdate

  return timeUpdate !== 0 && passedTime >= ttlTime
}
